import React from "react";

import classes from './map_page.module.css';

const MapPage = () => {
  return <div className={ classes.root }>
    <div>TODO: Make a map page</div>
  </div>
}

export default MapPage;
